import { render, staticRenderFns } from "./Deleted-profiles.vue?vue&type=template&id=38805ba8&"
import script from "./Deleted-profiles.vue?vue&type=script&lang=js&"
export * from "./Deleted-profiles.vue?vue&type=script&lang=js&"
import style0 from "./Deleted-profiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports